module.exports = __webpack_public_path__ + "img/fadian.79601e65.jpg";